import "../stylesheets/application.css";
import "@hotwired/turbo-rails";
import { enableTurboLogger } from "../lib";
import Alpine from "alpinejs";
import { pictureForm } from "../components";
import { alpineComponents } from "@tree-company/admin-components";

Alpine.data("pictureForm", pictureForm);
Alpine.data("notification", alpineComponents.notification);

document.addEventListener("DOMContentLoaded", () => {
  if (import.meta.env.DEV) enableTurboLogger();

  window.Alpine = Alpine;
  Alpine.start();
});
